import {
  isServerResponseError,
  hasError,
} from '../common'
import {
  pathOr,
  prop,
} from 'ramda'
import {
  getCustomerConsumptionBillingUsage
} from '../../services/apis'

const getConsumptionBillingData = async (id, from, to) => {
  const result = await getCustomerConsumptionBillingUsage(id)({
    from,
    to
  })
  return isServerResponseError(result) || hasError(result)
    ? []
    : pathOr([], ['data', 'data'], result)
}

export default getConsumptionBillingData
